<template>
  <div class="document-type-selectable-list-component" v-bind:class="{loaded}">
    <mortgage-progress-group-select-component v-on:change="onProgressGroupChange" v-bind:all-option="true"/>

    <a-input v-model="searchQuery" allow-clear placeholder="Zoeken" class="search-input">
      <magnify-icon slot="prefix"/>
    </a-input>

    <div class="document-type-list" v-if="loaded">
      <document-type-list-item-component v-for="documentType in filteredDocumentTypes"
                                         v-bind:document-type="documentType"
                                         v-bind:key="documentType.id"
                                         v-bind:selected="isDocumentTypeSelected(documentType)"
                                         v-on:click="onDocumentTypeSelect"/>
      <a-empty v-if="filteredDocumentTypesEmpty" description="Geen stukken gevonden" style="margin: 20px;"/>
    </div>
    <Skeleton v-else height="400px" style="display: block; margin-bottom: 15px;" v-bind:loading="true"></Skeleton>

    <a-row v-bind:gutter="16" style="margin-bottom: 10px;">
      <a-col v-bind:span="12" v-if="filteredDocumentsCount > 0">
        <p>Huidige lijst toevoegen</p>
        <a-button type="primary" v-bind:loading="loadingAll" v-on:click="onDocumentTypesSelect">Alles toevoegen
        </a-button>
      </a-col>
      <a-col v-bind:span="12" v-if="filteredDocumentsCount > 1">
        <p>Sorteer stukken op</p>

        <a-radio-group button-style="solid" v-model="sortType" v-if="loaded">
          <a-radio-button value="hdn">
            Document code
          </a-radio-button>
          <a-radio-button value="alfa">
            Naam
          </a-radio-button>
        </a-radio-group>
        <Skeleton v-else height="32px" width="200px" style="display: block;" v-bind:loading="true"></Skeleton>
      </a-col>
    </a-row>

    <a-row v-bind:gutter="16">
      <a-col v-bind:span="24">
        <p>Handmatig een stuk toevoegen</p>

        <a-input-search v-model="customTypeName" placeholder="Naam van het stuk" size="large"
                        v-on:search="onAddCustomType"

        >
          <a-button slot="enterButton" placeholder="Naam van het stuk"
                    type="primary" v-on:click="onAddCustomType"
                    v-bind:loading="loadingCustom"
                    :disabled="customTypeName.length < 1 || customTypeName.length > 100"
          >
            Toevoegen
          </a-button>
        </a-input-search>
        <small style="color:red;" v-if="customTypeName.length > 100">De maximale lengte is 100</small>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import documentTypeApi from '~/api/document_type'
import {Skeleton} from 'vue-loading-skeleton'
import DocumentTypeListItemComponent from './ListItemComponent'

export default {
  name: 'DocumentTypeSelectableListComponent',
  components: {
    DocumentTypeListItemComponent,
    Skeleton
  },
  props: {
    selectedDocumentTypes: {
      required: false,
      type: Array,
      default: function () {
        return []
      }
    },
    documentCodeType: {
      required: false,
      type: String,
      default: 'hdn',
    },
  },
  data() {
    return {
      documentTypes: [],
      mortgageProgressGroup: null,
      loaded: false,
      loadingAll: false,
      loadingCustom: false,
      searchQuery: '',
      sortType: 'hdn',
      customTypeName: '',
    }
  },
  mounted() {
    this.initDocumentTypes().then(() => {
      this.loaded = true
    })
  },
  computed: {
    mortgageProgressGroupedByStatus() {
      return this.mortgageProgress
    },
    mortgageProgressGroupDocumentTypes() {
      if (this.mortgageProgressGroup !== null) {
        return this.mortgageProgressGroup.document_types.data
      }

      return []
    },
    sortedDocumentTypes() {
      return this.documentTypes.sort((a, b) => {
        let aCompare, bCompare

        if (this.sortType === 'hdn') {
          aCompare = a.hdn_document_type
          bCompare = b.hdn_document_type
        } else {
          aCompare = a.name
          bCompare = b.name
        }

        if (aCompare < bCompare) {
          return -1
        }
        if (bCompare < aCompare) {
          return 1
        }

        return 0
      })
    },
    filteredDocumentTypes() {
      let filteredDocumentTypes = this.sortedDocumentTypes

      if (this.mortgageProgressGroupDocumentTypes.length > 0) {
        filteredDocumentTypes = filteredDocumentTypes.filter(documentType => {
          return (typeof this.mortgageProgressGroupDocumentTypes.find((item) => {
            return documentType.id === item.id
          })) !== 'undefined'
        })
      }
      if (this.searchQuery.length === 0) {
        return filteredDocumentTypes
      }

      return filteredDocumentTypes.filter(documentType => {
        return documentType.name.includes(this.searchQuery)
            || documentType.hdn_document_type.includes(this.searchQuery)
      })
    },
    filteredDocumentsCount() {
      return this.filteredDocumentTypes.length
    },
    filteredDocumentTypesEmpty() {
      return this.filteredDocumentsCount === 0
    }
  },
  methods: {
    isDocumentTypeSelected(documentType) {
      return this.selectedDocumentTypes.filter(item => item.id === documentType.id).length > 0
    },
    initDocumentTypes() {
      if (this.documentCodeType === 'hdn') {
        return documentTypeApi.getAllWithHDN().then(response => {
          this.documentTypes = response.data
        })
      } else {
        throw new Error('Not implemented yet')
      }
    },
    onProgressGroupChange(mortgageProgressGroup) {
      this.mortgageProgressGroup = mortgageProgressGroup
    },
    onDocumentTypeSelect(documentType, documentTypeItemComponent) {
      this.$emit('select', documentType, documentTypeItemComponent)
    },
    onDocumentTypesSelect() {
      let filtered = this.filteredDocumentTypes.filter(documentType => {
        return !this.isDocumentTypeSelected(documentType)
      })

      if (filtered.length === 0) {
        if (this.filteredDocumentTypes.length > 0) {
          this.$message.info('Alle stukken zijn reeds toegevoegd')
        } else {
          this.$message.info('Geen stukken om toe te voegen')
        }
      } else {
        this.loadingAll = true

        this.$emit('select-multiple', filtered, this)
      }
    },
    onAddCustomType() {
      this.loadingCustom = true

      this.$emit('select-custom', this.customTypeName, this)

      this.$nextTick(() => {
        this.customTypeName = '';
      });
    }
  }
}
</script>
<style scoped>
.mortgage-progress-edit-component {
  position: relative;
  margin-bottom: 15px;
}

.mortgage-progress-edit-component .search-input {
  margin: 15px 0;
}

.create-button {
  margin-top: 15px;
}

.document-type-list {
  margin-bottom: 15px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  line-height: 1.5;
  overflow-y: auto;
  max-height: 400px;
}

.document-type-list-item {
  padding: 8px 16px;
  border-bottom: 1px solid #e8e8e8;
}

.document-type-list-item .faded {
  opacity: 0.4;
  font-family: monospace;
  margin-right: 10px;
}

.document-type-list-item:last-child {
  border-bottom: none;
}

.document-type-list-item:hover {
  background-color: #ececec;
  cursor: pointer;
}
</style>
